import { render } from "./ModificaRapportinoAppuntamento.vue?vue&type=template&id=5b0b0ff1&scoped=true"
import script from "./ModificaRapportinoAppuntamento.vue?vue&type=script&lang=js"
export * from "./ModificaRapportinoAppuntamento.vue?vue&type=script&lang=js"

import "./ModificaRapportinoAppuntamento.vue?vue&type=style&index=0&id=5b0b0ff1&scoped=true&lang=css"

import exportComponent from "/Users/andrea/Sites/app_v2/app_entasys/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5b0b0ff1"]])

export default __exports__